<script setup>
import TagSelector from "@/components/table/CreateFeed/TagSelector.vue";
import CrossIcon from "@/components/icons/CrossIcon.vue";
import {ref} from "vue";

const emit = defineEmits(["update-tag-ids", "close-tag-editor"]);

const props = defineProps({
  sourceCount: {
    type: Number,
    required: true,
  }
});

const tagList = ref([]);
</script>

<template>
  <div class="tag-editor">
    <div class="tag-editor__header">
      <div class="tag-editor__title">
        Групповое добавление тегов ({{ props.sourceCount }} источников)
      </div>
      <div class="tag-editor__close-button">
        <CrossIcon @click="emit('close-tag-editor')" />
      </div>
    </div>
    <TagSelector
      :tag-list="tagList"
      @update-tag-ids="args => tagList.value = args"
    />
    <div class="tag-editor__control">
      <ButtonAccentPrimary
        size="large"
        @click="emit('update-tag-ids', tagList.value)"
      >
        Сохранить
      </ButtonAccentPrimary>
      <ButtonNeutralSecondary
        @click="emit('close-tag-editor')"
      >
        Отмена
      </ButtonNeutralSecondary>
    </div>
  </div>
</template>

<style scoped lang="scss">
.tag-editor {
  overflow-y: hidden;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
  width: 510px;
  height: 100%;
  padding: 20px 10px 20px 20px;
  background: #FFF;
  box-shadow: 0 4px 20px 0 #00000026;
  gap: 30px;

  &__header {
    display: flex;
    justify-content: space-between;
  }

  &__close-button {
    cursor: pointer;
    user-select: none;
    color: #CACACA;
  }

  &__title {
    font-size: 16px;
    font-weight: 500;
    color: #212327;
  }

  &__button-close {
    cursor: pointer;
    user-select: none;
    color: #A7A7A7;
  }

  &__button {
    width: 100%;
  }

  &__control {
    display: flex;
    gap: 24px;
  }

}
</style>